import React, { useState, useEffect, useRef } from 'react';

interface SearchBarProps {
  selectOptions : Set<string>
  selectedFilterOption : string
  setSelectedFilterOption : Function
}

export const SearchBar : React.FC<SearchBarProps> = ({selectOptions, selectedFilterOption, setSelectedFilterOption}) => {
  return (
    <div className="header-search-bar">
      <div>Filter by User</div>
      <select onChange={e => {
          (document.activeElement as HTMLElement).blur(); 
          setSelectedFilterOption(e.target.value)
        }} value={selectedFilterOption}>
        <option>None</option>
        {selectOptions && Array.from(selectOptions).map( o => <option key={o}>{o}</option>)}
      </select>
    </div>
  )
}
